<template>
  <div>
    <ModuleHeader>Reporte Descuentos</ModuleHeader>
    <v-overlay v-if="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col md="12" cols="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="2" cols="12">
                <v-menu v-model="menuFechaInicial" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="input_date" label="Fecha Inicial" prepend-icon="mdi-calendar" readonly
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="input_date" @input="menuFechaInicial = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="2">
                <v-menu v-model="menuFechaInicial2" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="input_date_final" label="Fecha Final" prepend-icon="mdi-calendar" readonly
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="input_date_final" @input="menuFechaInicial2 = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="2">
                <v-autocomplete label="Departamentos" v-model="selectDep" item-text="Nombre" item-value="id"
                  :items="departamentos"></v-autocomplete>
              </v-col>
              <v-col md="3">
                <v-autocomplete label="Cliente" item-value="value" v-model="selectClient"
                  :items="comp_clients"></v-autocomplete>
              </v-col>
              <v-col md="3">
                <v-text-field v-model="input_folio" label="Folio de Venta"></v-text-field>
              </v-col>
              <v-col md="3">
                <v-switch v-model="render" @change="datos = { processedData: [], all: [] }"
                  :label="`Mostrar Resultados`"></v-switch>
              </v-col>
              <v-col class="text-right mt-n5" md="12">
                <v-btn depressed @click="cleanFilter()" class="mx-2" color="error">
                  Restablecer Filtro
                </v-btn>
                <v-btn depressed @click="searchVentas()" color="success">
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="8">
                Resultados:
                <p v-if="!render && datos.processedData.length != 0">
                  <b> Descargue la hoja de excel para ver los resultados</b>
                </p>
                <p v-if="!render && datos.processedData.length == 0">
                  <b> Busqueda sin resultados</b>
                </p>
              </v-col>
              <v-col md="2" class="text-right">
                <v-btn v-if="false" @click="$router.push({ path: '/reportes/reportez' })" color="primary"
                  dark><v-icon>mdi-file-document-outline</v-icon>
                  Reporte Z
                </v-btn>
              </v-col>
              <v-col md="2" class="text-right">
                <v-btn color="green" dark @click="exportExcel()"><v-icon>mdi-file-excel-box</v-icon>
                  Exportar a Excel
                  <!-- <download-excel
                    type="xls"
                    name="Reporte General"
                    :data="datos.processedData"
                  >
                  </download-excel> -->
                </v-btn>
              </v-col>
            </v-row>
            <v-simple-table class="dense-table" v-if="render" dense>
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Cliente</th>

                  <th>Folio</th>
                  <th>Departamento</th>
                  <th>Clave SAT</th>
                  <th>Familia</th>
                  <th>Categoría</th>
                  <th>Producto</th>

                  <th>Cantidad Producto</th>
                   <th>Precio Total</th>
                  <th>Cantidad Descuento</th>
                  <th>Descripción</th>
                  <th>Descuento ({{ currencyClass.getCurrencyDefault() }})</th>

                  <th>Moneda</th>
                  <th v-if="false">
                    Subtotal ({{ currencyClass.getCurrencyDefault() }})
                  </th>
                  <th v-if="false">
                    Impuestos ({{ currencyClass.getCurrencyDefault() }})
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="datos.processedData.length == 0">
                  <td colspan="16">No se encontraron datos</td>
                </tr>
                <template v-for="(prod, index) in datos.processedData">
                  <tr :key="index">
                    <td>{{ prod.Fecha }}</td>
                    <td>{{ prod.Cliente }} {{ prod.Apodo }}</td>
                    <td>{{ prod.Folio }}</td>
                    <td>{{ prod.Departamento }}</td>
                    <td>{{ prod.ClaveSAT }}</td>
                    <td>{{ prod.Familia }}</td>
                    <td>{{ prod.Categoria }}</td>
                    <td>{{ prod.Producto }}</td>
                    
                    <td>{{ prod.Cantidad }}</td>
                    <td> ${{prod.Precio.C}} ${{prod.Precio.M}} </td>
                    <td>{{ prod.CantidadDescuento }}</td>
                    <td>{{ prod.Descripcion }}</td>
                    <td>
                      <b>{{ $pgsHelper.formatNumber(prod.Descuento) }}</b>
                    </td>

                    <td>{{ prod.Moneda }}</td>

                  </tr>
                </template>
                <tr style="background: #e0e0e04f">
                  <td><b>TOTALES</b></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <b>{{
                      this.$pgsHelper.formatNumber(comp_totales.Cantidad)
                      }}</b>
                  </td>
                  <td>
                    <b>{{this.$pgsHelper.formatNumber(comp_totales.CantidadDescuento)}}</b>
                  </td>
                  <td></td>
                  
                  <td>
                    <b>{{
                      this.$pgsHelper.formatNumber(
                        parseFloat(comp_totales.Descuento).toFixed(2)
                      )
                    }}</b>
                  </td>

                  <td></td>

                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped></style>

<script>
import "../../../assets/css/sideBar.css";
import Cliente from "../../../clases/Cliente.js";
import moment from "moment";
import Currency from "../../../clases/Currencies.js";
import Membresia from "../../../clases/Membresias/Membresia.js";
import Vue from "vue";
import GenericExcelExporter from "../../../clases/ExcelMaker/GeneralExcel";
import { mapActions } from "vuex";

export default {
  name: "ReporteDescuentos",
  components: {
    /*Select2,*/
  },
  props: ["hideMenu"],
  data() {
    return {
      selectDep: "ALL",
      currencyClass: Currency,
      menuFechaInicial: false,
      menuFechaInicial2: false,
      loadingData: false,
      render: true,
      datos: {
        all: [],
        processedData: [],
      },
      input_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      input_date_final: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      selectedRes: "",
      data_clientes: [],
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      showModal: false,
      formKey: 0,
      data_ventas: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      data_cajas: [],
      reservations: [],
      cashiers: [],
      Categories: [],
      familias: [],
      header: [
        "Cliente",
        "Membresia",
        "Folio",
        "Familia",
        "Categoría",
        "Descripción",
        "Cantidad",
        "Total",
        "Método de pago",
        "Autorización",
        "Total",
        "Impuestos",
      ],
      processedData: [],
    };
  },
  computed: {
    Membresias() {
      return this.$pgsHelper.indexBy(Membresia.getMembresiasList(), "Id");
    },
    selectedReserva() {
      return this.selectedRes;
    },
    comp_clients() {
      let clientes = [];
      let rowclientes = this.$pgsHelper.indexBy(Cliente.getClientsList(), "Id");
      rowclientes.forEach((cli) => {
        clientes.push({ value: cli.Id, text: cli.getNombreCompleto(), ...cli });
      });
      return clientes;
    },
    comp_totales() {
      let total = {
        Cantidad: 0,
        CantidadDescuento :0,
        Descuento: 0,
        Monto: 0,
        Subtotal: 0,
        Impuestos: 0,
      };
      this.datos.processedData.forEach((prod) => {
        total.Cantidad += Number(prod.Cantidad);
        let totalMonto = Number(prod.Subtotal) + Number(prod.Impuestos);
        total.Monto += Number(totalMonto);
        total.CantidadDescuento += Number(prod.CantidadDescuento)
        total.Descuento += Number(prod.Descuento);
        total.Subtotal += Number(prod.Subtotal);
        total.Impuestos += Number(prod.Impuestos);
      });
      return total;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
  },
  methods: {
    exportExcel() {
      GenericExcelExporter.generateExcelBuffer(this.datos.processedData)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "Reporte descuentos.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => console.error("Error exportando:", error));
    },
    processVentas() {
      console.time("ProcessVentas");
      let productosVenta = [];
      this.datos.all.forEach((el) => {
        let pagos = Object.entries(el.Pagos);
        const map = new Map();
        let client = this.$pgsHelper.searchIndex(
          this.comp_clients,
          "Id",
          el.Cliente.Id
        );
        /*let idMembresia = client.ExtraData?.Membresia?.Membresia;
        let Membresia = this.$pgsHelper.searchIndex(
          this.Membresias,
          "Id",
          idMembresia
        );*/
        el.Catalogo.forEach((prod) => {
          try {
            prod.Descuentos.forEach((desc) => {


              let producto = {
                Fecha: el.FechaVenta,
                Cliente: el.Cliente.Nombre,
                Apodo: el.Cliente.Apodo ? " - " + el.Cliente.Apodo : "",
                /* Membresia: Membresia
                  ? Membresia?.Code?.Pre + "-" + Membresia?.Code?.Pos
                  : "N/A",*/
                Folio: el.Folio,
                Departamento: el.Departamento,
                ClaveSAT: prod.Familia ? prod.Familia.C : "-",
                Familia: prod.Familia ? prod.Familia.N : "-",
                Categoria: prod.Categoria ? prod.Categoria.N : "-",
                Producto: prod.Nombre,
                Precio:prod.Pco,
                Cantidad: prod.Cnt,
                CantidadDescuento:desc.Cnt,
                Descuento:Number(desc.Ttl.C),
                Monto: Number(desc.Ttl.C),
                Moneda: desc.Ttl.M,
                Descripcion: desc?.Dsc,
                //Impuestos:((pago[1].def.C/100)*16),

              };

              productosVenta.push(producto);

            });
          } catch (e) {
            console.log(el.Folio);
          }
        });
      });
      this.datos.processedData = productosVenta;
      console.timeEnd("ProcessVentas");
    },
    cleanFilter() {
      this.input_date = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_date_final = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_folio = "";
      this.selectClient = "";
      this.selectDep = "ALL";
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas"
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getCashiers() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cashiers = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cashiers.push(toAdd);
          }
        });
      }
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getVentas() {
      const startDate = this.input_date;
      const endDate = this.input_date_final;
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("FechaVenta", ">=", startDate),
        firestore.where("FechaVenta", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ];

      if (this.selectDep != "ALL") {
        filter.push(firestore.where("Departamento", "==", this.selectDep));
      }

      if (this.input_folio != "") {
        filter.push(firestore.where("Folio", "==", this.input_folio));
      }

      if (this.selectClient != "") {
        filter.push(firestore.where("Cliente.Id", "==", this.selectClient));
      }

      const data = await firestore.queryBuilder("PDV_Ventas", filter);
      let preData = [];
      preData = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      preData.forEach((item) => {
        item.fecha = new moment(item.FechaCreacion).format("YYYY-MM-DD HH:mm");
      });

      preData = this.$_.orderBy(preData, "fecha", "desc");

      this.datos.all = preData;
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      this.Categories = await this.fetchCategories();
    },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );

      this.familias = [];
      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    searchVentas() {
      Promise.resolve()
        .then(() => {
          this.loadingData = true;
        })
        .then(() => {
          return this.getVentas();
        })
        .then(() => {
          this.loadingData = false;
        })
        .then(() => {
          return this.$nextTick();
        })
        .then(() => {
          this.processVentas();
        });
    },
  },
  beforeCreate: function () { },
  beforeMount: function () {
    this.getCategories();
    this.getFamilias();
    this.getCajas();
    this.getCashiers();
    this.$emit("useNav", true);
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
